import { CSS, StyleProps } from "@shared/primitive-components"

export const Container = (props: StyleProps): CSS => ({
  display: `flex`,
  flexDirection: `column`,
  gridGap: props.theme.spacing(4),
  width: `100%`,
})

export const DropdownContainer = (props: StyleProps): CSS => ({
  marginTop: props.theme.spacing(4),
  maxWidth: `400px`,
  width: `100%`,
})

export const DropdownTrigger = (props: StyleProps): CSS => ({
  backgroundColor: props.theme.palette.white,
  borderTopLeftRadius: `29px`,
  borderRadius: `29px`,
  color: props.theme.palette.coal.dark,
  "&:hover": {
    backgroundColor: props.theme.palette.white,
  },
})

export const TSPInfoText = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(1),
})

export const RemoveButton = (props: StyleProps): CSS => ({
  cursor: `pointer`,
  width: `20px`,
  height: `20px`,
  display: `flex`,
  justifyContent: `center`,
  alignItems: `center`,
  backgroundColor: props.theme.palette.full.red,
  borderRadius: `50%`,
  color: props.theme.palette.white,
})

export const TSPItem = (props: StyleProps): CSS => ({
  display: `flex`,
  justifyContent: `space-between`,
  marginTop: props.theme.spacing(4),
  padding: props.theme.spacing(2, 4, 2, 6),
  border: `1px solid ${props.theme.palette.grey.dark}`,
  borderRadius: `29px`,
  maxWidth: `400px`,
  width: `100%`,
})

export const NavigateToKnowledgePage = (props: StyleProps): CSS => ({
  display: `inline`,
  color: props.theme.palette.link,
  cursor: `pointer`,
  textDecoration: `underline`,
  whiteSpace: `nowrap`,
})
